import { render, staticRenderFns } from "./ModalViewAssessment.vue?vue&type=template&id=66511592&scoped=true"
import script from "./ModalViewAssessment.vue?vue&type=script&lang=js"
export * from "./ModalViewAssessment.vue?vue&type=script&lang=js"
import style0 from "./ModalViewAssessment.vue?vue&type=style&index=0&id=66511592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66511592",
  null
  
)

export default component.exports